"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var debug = require("debug")("views:ReaderView"); //https://github.com/visionmedia/debug

// Models
var PageSemanticModel = require("../models/page-semantic-model");
var UserModel = require("../../common/models/user-model");
var SelectedDocumentModel = require("../../common/models/selected-document-model");
var ArticleQueryModel = require("../../search/models/article-query-model");
var SharedCropModel = require("../models/shared-crop-model");

// Collections
var AnnotationCollection = require("../collections/annotation-collection");

// Views
var ClassificationView = require("../views/classification-view");
var OverlayEntitiesView = require("../views/overlay-entities-view");
var OverlayBlocksView = require("../views/overlay-blocks-view");
var OverlaySearchView = require("../views/overlay-search-view");
var OverlayCropView = require("../views/overlay-crop-view");
var OverlayAnnotationsView = require("../views/overlay-annotations-view");
var OverlayHighlightView = require("../views/overlay-highlight-view");
var BlocksView = require("../views/blocks-view");
var CalendarView = require("../views/calendar-view");
var SearchNextResultsView = require('../views/search-next-results-view');

// From pv5js
var DocumentModel = require("@immanens-com/pv5js/reader/models/document-model");
var DocumentView = require("@immanens-com/pv5js/reader/views/document-view");
var PageSliderView = require("@immanens-com/pv5js/reader/views/page-slider-view");
var UrlUtil = require("@immanens-com/pv5js/common/utils/url-util");
var SearchInputView = require("@immanens-com/pv5js/search/views/search-input-view");
var DomUtil = require("@immanens-com/pv5js/common/utils/dom-util");


var templates = {
    page: require("../templates/page-template.html"),
    pageSliderKnob: require("../templates/page-slider-knob-template.html"),
    pageSliderThumb: require("../templates/page-slider-thumb-template.html"),
    navigation: require("../templates/navigation-template.html"),
    searchNextResults: require("../templates/search-next-results-template.html")
};

/**
 * Retronews ReaderView : Main view for retronews reader page.
 * It contains a document surface, some toolbars and many other view displaying page's related informations (classification)
 */
module.exports = Backbone.View.extend({

    app: null, // store a reference to global app (mainly for configuration access)
    documentId: 0, //
    publicationId: 0, //
    routePublicationTitle: null, // titre à utiliser dans l'url
    routeDocumentDate: null, // date à utiliser dans l'url
    page: 1, // starting page
    fit: null, // try to fit specified rectangle {page,x,y,w,h} at startup
    articleId: null, // ouvre sur un article particulier
    from: "",
    embedWidth: 560,
    embedHeight: 315,
    embed: false,
    sliderHeight: 12,
    blockMode: "page",
    index: false,

    subViews: null, // array of subviews
    overlayViews: null, // array of page overlay views

    el: "#app-reader",
    events: {
        "click .button-down": "onMoreInfoClicked",
        "click .scroll-top": "onScrollTopClicked",
        "click .full-screen": "onFullscreenClicked",
        "click .help": "onHelpClicked",
        "click .image-inverse": "onImageInverseClicked",
        "click .entities": "onEntitiesClicked",
        "click .zoom-in": "onZoomInClicked",
        "click .zoom-out": "onZoomOutClicked",
        "click .ocr": "onOcrClicked",
        "click .calendar": "onCalendarClicked",
        "click .tb-top .basket": "onBasketClicked",
        "click .action.add-to-selection": "onAddToSelectionClicked",
        "click .access-selection": "onAccessSelectionClicked",
        "click .action.add-to-crop": "onAddToCropClicked",
        "click .action.url-crop": "onUrlCropClicked",
        "click .action.embed-crop": "onEmbedCropClicked",
        "click .action.download-crop": "onDownloadCropClicked",
        "click .access-crop": "onAccessCropClicked",
        "click .annotation-delete": "onDeleteAnnotation",
        "click .action.annotation-save": "onSaveAnnotation",
        "click .download-document": "onDownloadDocumentClicked",
        "click .print-document": "onPrintDocumentClicked",
        "click .next-page": "onNextPage",
        "click .previous-page": "onPreviousPage",
        "click .subscribe": "onSubscribeClicked",
        "click .login": "onLoginClicked",
        "click .register": "onRegisterClicked",
        "click .facebook": "onShareFacebookClicked",
        "click .twitter": "onShareTwitterClicked",
        "click .action.email": "onShareEmailClicked",
        "click .result .next": "onNextResult",
        "click .result .previous": "onPreviousResult",
        "click .tb-top .button": "onDisplayPanel",
        "click .tb-top .close": "onClosePanel",
        "click .tb-top .minimize": "onMinimizePanel",
        "click .tb-right .basket": "onBasketClicked",
        "click .tb-bottom .retronews-go": "onDiscoverClicked",
        "click .embed-popup": "onEmbedPopupClicked",
        "change #embed-size-select": "onEmbedSizeChanged",
        "change #embed-custom-width": "onEmbedWidthChanged",
        "change #embed-custom-height": "onEmbedHeightChanged",
        "focus #print-text-some-pages": "onPrintTextFocused",
        "focus #download-text-some-pages": "onDownloadTextFocused",
        "focus #embed-code": "onEmbedCodeFocused",
        "keyup #embed-custom-width": "limitInputToNumbers",
        "keyup #embed-custom-height": "limitInputToNumbers",
        "keyup #print-text-some-pages": "limitInputToNumbers",
        "keyup #download-text-some-pages": "limitInputToNumbers",
        "pointerdown .overlay-embed": "onOverlayEmbedTouchStart",
        "touchstart .overlay-embed": "onOverlayEmbedTouchStart",
        "mousewheel .overlay-embed":"onOverlayEmbedMouseWheel",
        "DOMMouseScroll .overlay-embed":"onOverlayEmbedMouseWheel",
        "click .activate-embed":"onActivateEmbed"
    },

    /**
     * @param  {Object} options must contains the "app" object
     */
    initialize: function (options) {
        var T = this;

        _.extend(T, options);

        T.subViews = [];
        T.overlayViews = []; // page overlays
        T._semanticModels = []; // page semantic models

        // user
        T.userModel = new UserModel(T.app.user);

        // en admin on veut voir tous les documents, les utilisateurs eux ne doivent voir que ce qui à été validé (access=public)
        T.searchAccess = T.userModel.isAdmin() ? null : "public";

        // search query for entire document
        T.documentQueryModel = new ArticleQueryModel({
            useAgg: false,
            documentId: T.documentId,
            publicationId: T.publicationId,
            highlight: false,
            sort: "page-number",
            access: T.searchAccess
        }, {
                pv5api: T.app.pv5api,
                minPublishedDate: T.app.minPublishedDate,
                maxPublishedDate: T.app.maxPublishedDate
            });
        T.listenTo(T.documentQueryModel, "sync", T.onDocumentSearchEnd);
        T._pageQueryModels = []; // search queries for each page

        T.pageTermsView = new SearchInputView({
            model: T.documentQueryModel,
            el: "#search-input-phrase",
            fieldName: "phrase"
        });
        T.listenTo(T.pageTermsView, "submit", T.onSubmitSearch);
        T.subViews.push(T.pageTermsView);

        // le mode embed est passé en paramètre
        if (T.app.embed) {
            T.embed = true;
            T.$el.addClass("embed");
        }

        // settings
        T._entitiesShown = false;
        T._blocksShown = false;
        T._calendarShown = false;
        T._sidePanel = false;
        T._imageInverted = false;
        T._cropShown = false;
        T._annotateActive = false;

        T.readSettings();

        if (T.app.bot) {
            // on affiche le texte pour les robots
            T._sidePanel = true;
            T._blocksShown = true;
            T.$el.addClass("bot");
        }

        if (T.articleId) {
            T._blocksShown = true; // on affiche un article au chargement du document
            T.blockMode = "article";
        }

        $(window).on("unload.rn", function () {
            T.writeSettings();
        });

        //console.log("from: "+T.from);

        if (T.userModel.isPremium()) {
            T.$el.addClass("premium");
        }
        if (T.userModel.isBnf()) {
            T.$el.addClass("bnf");
        }
        if (T.userModel.isAdmin()) {
            T.$el.addClass("admin");
        }
        if (T.userModel.isLoggedIn()) {
            T.$el.addClass("logged");
        }

        // gère l'affichage de panneaux selon le niveaux de l'utilisateur
        if (T.userModel.isPremium()){
            if(T.userModel.isLoggedIn()){
                //
                T.$(".dropdown .content.premium .verified").show();
                T.$(".dropdown .content.premium .lambda").hide();
                T.$(".dropdown .content.premium .anonymous").hide();
             }
            else{
                //
                T.$(".dropdown .content.premium.need-login .verified").hide();
                T.$(".dropdown .content.premium.need-login .lambda").hide();
                T.$(".dropdown .content.premium.need-login .anonymous").show();
                T.$(".dropdown .content.premium:not(.need-login) .verified").show();
                T.$(".dropdown .content.premium:not(.need-login) .lambda").hide();
                T.$(".dropdown .content.premium:not(.need-login) .anonymous").hide();
            }
        }
        else{
            T.$(".dropdown .content.premium .verified").hide();
            T.$(".dropdown .content.premium .lambda").show();
            T.$(".dropdown .content.premium .anonymous").hide();
        }
        

        if (T.from && T.from.substr(0, 7) == "/search") {
            T.$el.addClass("from-search");

            var from_split = T.from.split("#", 2);
            if (from_split.length == 2 && T.index !== false) {
                var query_string = decodeURIComponent(from_split[1]);
                T.searchNextResultsView = new SearchNextResultsView({
                    app: T.app,
                    searchQuery: query_string,
                    index: T.index,    
                    el: ".search-next-results",
                    template: templates.searchNextResults
                });
                T.subViews.push(T.searchNextResultsView);
            }            
        }

        // fullscreen
        $(document).on("webkitfullscreenchange.rn mozfullscreenchange.rn fullscreenchange.rn MSFullscreenChange.rn", function (e) {
            T.onFullscreenChanged(e);
        });

        T.documentModel = new DocumentModel({
            id: T.documentId,
            publicationId: T.publicationId
        }, {
                pv5api: T.app.pv5api
            });

        // annotation pour tout le document
        T.annotationCollection = new AnnotationCollection(null, {
            rnapi: T.app.rnapi,
            documentId: T.documentId,
            publicationId: T.publicationId
        });

        // page thumbnail slider view
        T.pageSliderView = new PageSliderView({
            model: T.documentModel,
            el: ".page-slider",
            templateKnob: templates.pageSliderKnob,
            templateThumb: templates.pageSliderThumb,
            embed: T.embed
        });
        T.subViews.push(T.pageSliderView);

        // main document view
        T.documentView = new DocumentView({
            model: T.documentModel,
            el: ".document-view",
            pageTemplate: templates.page,
            zoomMax: 2,
            embed: T.embed
        });
        T.listenTo(T.documentView, "add:page-view", T.onPageViewAdded);
        T.listenTo(T.documentView, "render:page-view", T.onPageViewRendered);
        T.listenTo(T.documentView, "remove:page-view", T.onPageViewRemoved);
        T.subViews.push(T.documentView);


        if (!T.embed) {
            // view nécessaires pour le lecteur complet seulement
            // classification datas
            T.classificationView = new ClassificationView({
                model: T.documentModel,
                el: ".classification article",
                userModel: T.userModel,
                app: T.app
            });
            T.subViews.push(T.classificationView);

            // add link to see all issues of this publication
            T.$(".see-all-issues a").attr("href", "/search"); // todo : update url
        }
        else {
            // if embedded and in retronews.fr, don't display the subscribe button
            try {
                var url = (window.location != window.parent.location) ? document.referrer : document.location.href;

                if(url.indexOf('retronews.fr') !== -1) {
                    T.$el.addClass("bnf-embed");
                }
            }
            catch (err) {
                debug('cannot access parent url');
            }
            T.$overlayEmbed=T.$(".overlay-embed");
        }

        // render each sub views
        T.subViews.forEach(function (view) {
            view.render();
        });

        T.echoVersion();
        T.updateNavigation();

        $(document).on("keydown.rn", function (e) {
            T.onKeyDown(e);
        });
        $(document).on("keyup.rn", function (e) {
            T.onKeyUp(e);
        });

        T.listenTo(T.app, "app:notify", T.notify);

        T.listenTo(T.documentModel, "sync", T.onDocumentLoaded);
        T.listenTo(T.documentModel, "change:page", T.onPageChanged);

        T.documentModel.fetch({
            error: function () {
                T.notify({
                    text: STR.document_not_found,
                    type: "error",
                    timeout: 4000
                });
            }
        });



        $(window).on("resize.rn", function () {
            T.onResize();
        });

    },

    onResize: function () {
        var T = this;
        T.pageSliderView.resize();
        T.documentView.resize();
        // on limite la hauteur des panneau
        var height = T.$(".document-view").height() - 36; // hauteur du header
        T.$(".dropdown > .content").css("max-height", height);
    },

    writeSettings: function () {
        var T = this;

        // si mode embed on ne sauve pas les settings
        if (T.embed) return;

        var settings = {
            sidePanel: T._sidePanel,
            entitiesShown: T._entitiesShown,
            blocksShown: T._blocksShown,
            calendarShown: T._calendarShown,
            imageInverted: T._imageInverted,
            blockMode: T.blockMode
        };

        localStorage.setItem("reader-settings", JSON.stringify(settings));
    },

    readSettings: function () {
        var T = this;

        // si mode embed on ne tient pas compte des settings
        if (T.embed) return;

        var settings = JSON.parse(localStorage.getItem("reader-settings"));
        if (settings) {
            T._entitiesShown = settings.entitiesShown || T._entitiesShown;
            T._blocksShown = settings.blocksShown || T._blocksShown;
            T._calendarShown = settings.calendarShown || T._calendarShown;
            T._sidePanel = settings.sidePanel || T._sidePanel;
            T._imageInverted = settings.imageInverted || T._imageInverted;
            T.blockMode = settings.blockMode || T.blockMode;
        }
    },

    onDocumentLoaded: function () {
        var T = this;

        if (T.documentModel.get("isTextMissing")) {
            T.notify({
                text: STR.text_is_missing,
                type: "warning",
                timeout: 5000
            });
        }

        T.updateDocumentTitle();

        T.documentQueryModel.set("pageSize", T.documentModel.get("nbPages") * 20); // on multiplie par 20 car on ne peut pas avoir plus de 20 articles par page

        if (T.from && T.from.substr(0, 7) == "/search") {

            // on vient de la recherche, on relance la même recherche en spécifiant le document actuel
            var from_split = T.from.split("#", 2);
            if (from_split.length == 2) {
                var query_string = decodeURIComponent(from_split[1]);
                var temp_query = new ArticleQueryModel({}, {
                    pv5api: T.app.pv5api
                });
                temp_query.setQueryString(query_string);
                // on vérifie que ce n'est pas une recherche sans mots, avec juste des filtres par exemple auquel cas on aurait rien à highlighter
                if (temp_query.hasTerms()) {
                    // on recopie les champs utiles dans la recherche document
                    T.copyQueryTerms(temp_query, T.documentQueryModel);
                    T.documentQueryModel.search();
                }
            }
        }

        if (T._blocksShown) {
            T.displayBlocks(T._blocksShown);
        } else if (T._calendarShown) {
            T.displayCalendar(T._calendarShown);
        }
        T.imageInverse(T._imageInverted);
        T.displayEntities(T._entitiesShown);
        T.documentView.gotoPage(T.page, false, T.fit);

        if (T.userModel.isLoggedIn()) {
            T.annotationCollection.fetch();
        }
    },

    onPageChanged: function () {
        var T = this;

        if (!T.articleId) {
            // détection changement de page au fil de l'eau ou changement de page initial ?
            T.currentArticleId = null;
        }

        T.updateRoute();
        T.updatePageTitle();

        if (T._blocksShown) {
            T.updateBlocksView();
        }

        T.trackPage();
    },

    trackPage: function () {
        var T = this;
        if (!T.documentModel.fetched) return;

        if (_.isFunction(T.app.trackPage)) {
            var doc_obj = _.clone(T.documentModel.toJSON());
            delete (doc_obj.pages);
            T.app.trackPage(doc_obj);
        }

        // tracking google analytics par défaut
        if (T.app.googleAnalytics.enable && _.isFunction(window.ga)) {

            var pubtitle = T.documentModel.get("publicationTitle");
            var pubid = T.documentModel.get("publicationId");
            var doctitle = T.documentModel.get("title");
            var docid = T.documentModel.get("id");
            var docdate = T.documentModel.get("published");
            var page = T.documentModel.get("page");
            var year = docdate.split("-")[0];

            var path = T.app.googleAnalytics.path;
            path += "/" + pubtitle + "_" + pubid + "/" + year + "/" + doctitle + "_" + docid + "/" + page;
            debug("ga tracking page %s", path);
            window.ga("send", "pageview", path);
        }

    },

    trackEventReader: function (label) {
        this.trackEvent("lecteur", (this.embed ? 'embedded' : 'normal'), label);
    },

    trackEvent: function (category, action, label) {
        var T = this;

        if (T.app.googleAnalytics.enable && _.isFunction(window.ga)) {
            debug("ga tracking event %s %s %s", category, action, label);
            window.ga("send", "event", category, action, label);
        }
    },


    getSemanticModel: function (page) {
        var T = this,
            semantic_model = _.findWhere(T._semanticModels, {
                id: page
            });

        if (!semantic_model) {
            semantic_model = new PageSemanticModel({
                publicationId: T.publicationId,
                documentId: T.documentId,
                id: page
            }, {
                    pv5api: T.app.pv5api
                });
            T._semanticModels.push(semantic_model);

            if (!T.documentModel.get("isTextMissing")) {
                semantic_model.fetch();
            }
        }
        return semantic_model;
    },

    updateRoute: function () {
        var T = this,
            route = T.documentModel.get("publicationId") + "/" + T.documentModel.get("id") + "/" + T.documentModel.get("page");

        if (T.routePublicationTitle && T.routeDocumentDate) {
            route = T.routePublicationTitle + "/" + T.routeDocumentDate + "/" + route;
        }

        if (T.embed) {
            // en mode embed, on met à jour le lien vers la page également
            T.$(".goto-document").attr("href", T.canonicalReaderUrl());

            // on ne met pas à jour la route en mode embed pour avoir une référence constante avec le paramètre fit
            return;
        }

        if (T.currentArticleId) {
            route += "/" + T.currentArticleId;
        }

        if (T.from && T.page == T.documentModel.get("page")) {
            route += "?from=" + encodeURIComponent(T.from) + (T.index !== false && T.index !== undefined ? '&index='+T.index : '');
        }

        T.app.router.navigate(
            route, {
                trigger: false,
                replace: true
            }
        );
    },

    /**
     * mise à jour du titre du journal et de la référence du document
     * fait une fois lors du chargement du modèle de document
     */
    updateDocumentTitle: function () {
        var T = this;
        if (!T.documentModel.fetched) return;

        var pub_title = T.documentModel.get("publicationTitle"),
            doc_title = STR.date(T.documentModel.get("published"));
        T.$(".tb-top .ref .ref-publication").text(pub_title + ", ");
        T.$(".tb-top .ref .ref-title").text(doc_title + ", ");

    },

    updatePageTitle: function () {
        var T = this;
        if (!T.documentModel.fetched) return;

        // update title and metadatas
        var page_title = "p. " + T.documentModel.get("page") + "/" + T.documentModel.get("nbPages");
        T.$(".tb-top .ref .ref-page").text(page_title);
    },

    /**
     * [updateEmbedCode description]
     * @param  {[type]} type   [description]
     * @param  {[type]} width  [description]
     * @param  {[type]} height [description]
     * @return {[type]}        [description]
     */
    updateEmbedCode: function (src, width, height) {
        var T = this;

        if (!src) return;

        T.currentEmbedSrc = src;

        var code = "<iframe width=\"" + width + "\" height=\"" + height + "\" src=\"" + src + "\" frameborder=\"0\"></iframe>";

        T.$("#embed-code").val(code);

        if (T.openPanel == "embed") {
            T.displayEmbedPreview(true);
        }
    },

    /**
     * mise à jour du code de la textarea du code embed avec la page courante
     */
    updateEmbedCodePage: function () {
        var T = this;
        var url = T.canonicalReaderUrl(false, false, true);

        var current_page = T.documentModel.get("page"),
            page_model = T.documentModel.getPageModel(current_page);

        if (page_model.fetched) {
            T.embedRatio = page_model.get("width") / page_model.get("height");
        } else {
            T.embedRatio = 1;
        }

        var size = T.getEmbedSize();
        var size_choice = T.$("#embed-size-select").val();
        if (size_choice == "ratio") {
            var new_height = Math.round(size.width / T.embedRatio) + T.sliderHeight;
            T.$("#embed-custom-height").val(new_height);
            T.updateEmbedCode(url, size.width, new_height);
        } else {
            T.updateEmbedCode(url, size.width, size.height);
        }
    },

    /**
     * Ecrit le code pour l'embed du crop dans le textarea du panneau embed
     */
    onEmbedCropClicked: function () {
        var T = this;

        var crop = T.currentCrop();
        if (!crop) {
            return;
        }

        var src = T.canonicalReaderUrl(false, crop, true);
        T.embedRatio = crop.width / crop.height;

        var size = T.getEmbedSize();

        var size_choice = T.$("#embed-size-select").val();
        if (size_choice == "ratio") {
            var new_height = Math.round(size.width / T.embedRatio) + T.sliderHeight;
            T.$("#embed-custom-height").val(new_height);
            T.updateEmbedCode(src, size.width, new_height);
        } else {
            T.updateEmbedCode(src, size.width, size.height);
        }

        T.closePanel();
        T.displayPanel("embed");
        T.$("#embed-code").focus();

        T.trackEventReader("integrer");

    },

    getEmbedSize: function () {
        var T = this,
            width, height;
        var size = T.$("#embed-size-select").val();
        if (size == "custom" || size == "ratio") {
            width = T.$("#embed-custom-width").val();
            height = T.$("#embed-custom-height").val();
        } else {
            var size_split = size.split("x");
            width = size_split[0];
            height = size_split[1];
        }
        return {
            width: parseInt(width),
            height: parseInt(height)
        };
    },

    onEmbedSizeChanged: function () {
        var T = this;

        var size_choice = T.$("#embed-size-select").val();
        if (size_choice == "custom" || size_choice == "ratio") {
            T.$(".embed-size .custom-size").show();
            if (size_choice == "ratio") {
                T.$("#embed-custom-width").val(T.embedWidth);
                T.$("#embed-custom-height").val(Math.round(T.embedWidth / T.embedRatio) + T.sliderHeight);
            } else {
                T.$("#embed-custom-width").val(T.embedWidth);
                T.$("#embed-custom-height").val(T.embedHeight);
            }
        } else {
            T.$(".embed-size .custom-size").hide();
        }
        var size = T.getEmbedSize();
        T.updateEmbedCode(T.currentEmbedSrc, size.width, size.height);
    },

    onEmbedWidthChanged: function () {
        var T = this,
            size = T.getEmbedSize(),
            size_choice = T.$("#embed-size-select").val();

        if (size_choice == "ratio") {
            size = T.getEmbedSize();
            var new_height = Math.round(size.width / T.embedRatio) + T.sliderHeight;
            T.$("#embed-custom-height").val(new_height);
            T.updateEmbedCode(T.currentEmbedSrc, size.width, new_height);
        } else if (size_choice == "custom") {
            size = T.getEmbedSize();
            T.updateEmbedCode(T.currentEmbedSrc, size.width, size.height);
        }
    },

    onEmbedHeightChanged: function () {
        var T = this,
            size = T.getEmbedSize(),
            size_choice = T.$("#embed-size-select").val();

        if (size_choice == "ratio") {
            var new_width = Math.round((size.height - T.sliderHeight) * T.embedRatio);
            T.$("#embed-custom-width").val(new_width);
            T.updateEmbedCode(T.currentEmbedSrc, new_width, size.height);
        } else if (size_choice == "custom") {
            T.updateEmbedCode(T.currentEmbedSrc, size.width, size.height);
        }
    },

    onEmbedPopupClicked: function () {
        var T = this,
            size = T.getEmbedSize();

        if (T.currentEmbedSrc) {
            window.open(T.currentEmbedSrc, '', 'height=' + size.height + ',width=' + size.width + ',resizable=no,menubar=no,scrollbars=no,status=no');
        }
    },

    /**
     * Update navigation bar (fil d'arianne).
     * If we came from a search page, output number of results and a back link.
     */
    updateNavigation: function () {
        // search /search/?xxx=yyy&total=1234 in query string
        var T = this,
            url,
            total;

        if (T.from && T.from.substr(0, 7) == "/search") {
            var q = UrlUtil.parseQueryString(T.from, ["total"]);
            url = T.from;
            total = q.total;
        }

        if (url && total) {
            var template = _.template(templates.navigation);
            T.$(".back-to-search").html(template({
                url: url,
                total: total
            }));
        }
    },

    /**
     * [onKeyDown description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    onKeyDown: function (e) {
        var T = this,
            prevent = false,
            isEditing = DomUtil.isEditing(e);

        if (!isEditing) {
            // shortcuts only available if user is not entering text in an input
            if (e.keyCode == 39) {
                //"right" : next page
                T.documentView.gotoPage("next", true);
                prevent = true;
            } else if (e.keyCode == 37) {
                //"left" : previous page
                T.documentView.gotoPage("previous", true);
                prevent = true;
            } else if (e.keyCode == 32) {
                //"space" : goto classification
                if ($(document).scrollTop()) {
                    T.onScrollTopClicked();
                } else {
                    T.onMoreInfoClicked();
                }
                prevent = true;
            } else if (e.keyCode == 70) {
                // f : find
                T.closePanel();
                T.displayPanel("search");
                prevent = true;
            } else if (e.keyCode == 68) {
                // d : découpage
                T.closePanel();
                T.displayPanel("crop");
                prevent = true;
            } else if (e.keyCode == 17) {
                // ctrl : temporarily disable tool
                T.$(".overlay-crop").addClass("inactive");
            }
        }

        if (e.keyCode == 27) {
            // ESC : close pannel = stop tool
            T.closePanel();
            prevent = true;
        }

        if (prevent) {
            e.preventDefault();
        }

    },

    onKeyUp: function (e) {
        var T = this,
            prevent = false,
            isEditing = DomUtil.isEditing(e);

        if (!isEditing) {
            // shortcuts only available if user is not entering text in an input
            if (e.keyCode == 17) {
                T.$(".overlay-crop").removeClass("inactive");
            }
        }

        if (prevent) {
            e.preventDefault();
        }
    },


    /**
     * scroll page to classify data block
     * @return {[type]} [description]
     */
    onMoreInfoClicked: function () {
        $("html, body").animate({
            scrollTop: $("section.classification").offset().top
        }, 500);
    },

    onAddToSelectionClicked: function () {
        var T = this;

        if (!T.documentModel.fetched) return;

        var pubTitle = T.documentModel.get("publicationTitle"),
            published = T.documentModel.get("published"),
            documentId = T.documentModel.get("id"),
            publicationId = T.documentModel.get("publicationId"),
            page = T.documentModel.get("page");

        if (!T.userModel.isLoggedIn()) {
            T.app.loginScreen();
            return;
        }

        T.notify({
            text: STR.save_in_progress + "...",
            type: "info",
            timeout: 3000
        });

        T.closePanel();

        var se = new SelectedDocumentModel({
            documentId: documentId,
            publicationId: publicationId,
            publicationTitle: pubTitle,
            publicationDate: published,
            page: page
        }, {
                rnapi: T.app.rnapi
            });
        se.save(null, {
            success: function () {
                T.notify({
                    text: STR.save_ok,
                    type: "info",
                    timeout: 1000
                });
            },
            error: function () {
                T.notify({
                    text: STR.unable_to_save,
                    type: "error",
                    timeout: 4000
                });
            }
        });
        T.trackEventReader("mes-selections");
    },

    onAccessSelectionClicked: function () {
        window.location = "/utilisateur/" + this.userModel.get("id") + "/selections";
    },

    /**
     * Compute current cropped area
     * @return {[type]} [description]
     */
    currentCrop: function () {
        var T = this,
            current_page = T.documentModel.get("page"),
            page_model = T.documentModel.getPageModel(current_page),
            page_width = page_model.get("width"),
            page_height = page_model.get("height"),
            crop = null;

        // recherche de l'overlay de la page courante
        var overlay_views = _.where(T.overlayViews, {
            page: current_page
        });
        overlay_views.forEach(function (overlay_view) {
            if (overlay_view instanceof OverlayCropView) {
                crop = {
                    x: Math.round(overlay_view.selection.x * page_width / 100),
                    y: Math.round(overlay_view.selection.y * page_height / 100),
                    width: Math.round(overlay_view.selection.width * page_width / 100),
                    height: Math.round(overlay_view.selection.height * page_height / 100)
                };
            }
        });

        return crop;
    },

    /**
     * Enregistrer dans mes découpages
     */
    onAddToCropClicked: function () {
        var T = this;

        if (!T.documentModel.fetched) return;

        var pubTitle = T.documentModel.get("publicationTitle"),
            published = T.documentModel.get("published"),
            documentId = T.documentModel.get("id"),
            publicationId = T.documentModel.get("publicationId"),
            page = T.documentModel.get("page");

        if (!T.userModel.isLoggedIn()) {
            T.app.loginScreen();
            return;
        }

        // recherche du crop courant

        T.notify({
            text: STR.save_in_progress + "...",
            type: "info",
            timeout: 3000
        });

        T.closePanel();

        var crop = T.currentCrop();
        if (!crop) {
            return;
        }

        //console.log(crop);

        var options = {
            documentId: documentId,
            publicationId: publicationId,
            publicationTitle: pubTitle,
            publicationDate: published,
            page: page
        };
        _.extend(options, crop);

        var sc = new SharedCropModel(
            options, {
                rnapi: T.app.rnapi
            }
        );
        sc.save(null, {
            success: function () {
                T.notify({
                    text: STR.save_ok,
                    type: "info",
                    timeout: 1000
                });
            },
            error: function () {
                T.notify({
                    text: STR.unable_to_save,
                    type: "error",
                    timeout: 4000
                });
            }
        });
        T.trackEventReader("extraire");
    },

    onDownloadCropClicked: function () {
        var T = this;
        if (!T.documentModel.fetched) return;

        var crop = T.currentCrop();
        if (!crop) {
            return;
        }

        var picture = T.documentModel.pageUrl(T.documentModel.get("page")) + "/crop-rect/" + crop.x + "/" + crop.y + "/" + crop.width + "/" + crop.height;

        //console.log(picture);
        window.open(picture, "_blank");
    },

    onUrlCropClicked: function () {
        var T = this;
        if (!T.documentModel.fetched) return;

        var crop = T.currentCrop();
        if (!crop) {
            return;
        }

        var url = window.location.href.split('?')[0]; // url sans la query string
        /*if (T.app.hostname) {
            var url_obj = new URL(url);
            url_obj.hostname = T.app.hostname;
            url = url_obj.href;
        }*/
        url += "?highlight=" + crop.x + "." + crop.y + "." + crop.width + "." + crop.height;

        T.copyTextToClipboard(url);
        T.notify(
            {
                text: STR.copy_url_ok,
                type: "info",
                timeout: 10000
            });
        //window.prompt("Copier/Coller cette URL pour accéder directement à cette page avec la zone surligée dans le lecteur", url);
    },

    /**
     * Accéder à mes découpages
     */
    onAccessCropClicked: function () {
        var T = this;
        window.location = "/utilisateur/" + T.userModel.get("id") + "/extraits";
    },

    onSubscribeClicked: function () {
        window.location = "/abonnement";
        this.trackEventReader("abonnez-vous");
    },

    onDiscoverClicked: function () {
        this.trackEventReader("testez-retronews");
    },

    onLoginClicked: function () {
        window.location = "/user/login";
    },

    onRegisterClicked: function () {
        window.location = "/user/register";
    },

    copyTextToClipboard: function (text) {
        var textArea = document.createElement("textarea");

        //
        // *** This styling is an extra step which is likely not required. ***
        //
        // Why is it here? To ensure:
        // 1. the element is able to have focus and selection.
        // 2. if element was to flash render it has minimal visual impact.
        // 3. less flakyness with selection and copying which **might** occur if
        //    the textarea element is not visible.
        //
        // The likelihood is the element won't even render, not even a flash,
        // so some of these are just precautions. However in IE the element
        // is visible whilst the popup box asking the user for permission for
        // the web page to copy to the clipboard.
        //

        // Place in top-left corner of screen regardless of scroll position.
        textArea.style.position = 'fixed';
        textArea.style.top = 0;
        textArea.style.left = 0;

        // Ensure it has a small width and height. Setting to 1px / 1em
        // doesn't work as this gives a negative w/h on some browsers.
        textArea.style.width = '2em';
        textArea.style.height = '2em';

        // We don't need padding, reducing the size if it does flash render.
        textArea.style.padding = 0;

        // Clean up any borders.
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';

        // Avoid flash of white box if rendered for any reason.
        textArea.style.background = 'transparent';


        textArea.value = text;

        document.body.appendChild(textArea);

        textArea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            console.log('Copying text command was ' + msg);
        } catch (err) {
            console.log('Oops, unable to copy');
        }

        document.body.removeChild(textArea);
    },

    onShareFacebookClicked: function () {
        //https://developers.facebook.com/docs/sharing/reference/feed-dialog/v2.4
        var T = this,
            url,
            pubTitle = T.documentModel.get("publicationTitle"),
            published = T.documentModel.get("published"),
            message = STR.facebook_message,
            app_id = T.app.facebookAppId,
            caption = pubTitle + ", " + STR.date(published),
            picture = T.documentModel.thumbnailUrl(T.documentModel.get("page"));

        T.closePanel();

        if (T.embed) {
            url = T.canonicalReaderUrl(true, T.fit); // en mode embed on veut partager l'url originale
        } else {
            url = T.canonicalReaderUrl();
        }

        window.open(UrlUtil.shareFacebook(
            app_id, {
                display: "page",
                caption: caption,
                description: message,
                link: url,
                picture: picture
            }), "_blank");

    },

    onShareTwitterClicked: function () {
        var T = this,
            url,
            pubTitle = T.documentModel.get("publicationTitle"),
            published = T.documentModel.get("published"),
            message = pubTitle + ", " + STR.date(published); // use template ?

        

        if (T.embed) {
            url = T.canonicalReaderUrl(true, T.fit); // en mode embed on veut partager l'url originale
        } else {
            url = T.canonicalReaderUrl();
        }

        T.closePanel();
        window.open(UrlUtil.shareTwitter(message, url, "RetroNewsFR"), "_blank");
        T.trackEvent('lecteur', 'partager', 'twitter');
    },

    onShareEmailClicked: function () {
        var T = this,
            pubTitle = T.documentModel.get("publicationTitle"),
            published = T.documentModel.get("published"),
            subject = "Lu sur retronews.fr",
            url = T.canonicalReaderUrl(),
            message = pubTitle + ", " + STR.date(published) + "\r\n\r\nConsultez cette page sur RetroNews :\r\n" + url + "\r\n\r\nRetroNews, le site de presse de la Bibliothèque nationale de France";

        var link = "mailto:?subject=" + window.encodeURIComponent(subject) + "&body=" + window.encodeURIComponent(message);
        T.closePanel();
        window.location.href = link;

        T.trackEvent('lecteur', 'partager', 'email');
    },


    onEmbedCodeFocused: function (e) {
        e.target.select();
    },

    onDownloadTextFocused: function () {
        this.$("#download-pdf-some-page").prop("checked", true);
    },

    onDownloadDocumentClicked: function () {
        var T = this,
            filename = (T.documentModel.get("published") +" "+ T.documentModel.get("publicationTitle") + " " + "Retronews").replace(/[^A-Za-z0-9]/g, "_"),
            page = 1,
            service = "pdf",
            error_str = null;

        var type = T.$("input[name='download-group']:checked").val();
        if (type == "active-page") {
            page = T.documentModel.get("page");
        } else if (type == "some-pages") {
            page = T.$("#download-text-some-pages").val().trim();

            if (!T.checkPrintRangeSyntax(page, T.documentModel.get("nbPages"))) {
                error_str = STR.wrong_syntax_pages;
            }
        } else if (type == "all-pages") {
            page = "1-" + T.documentModel.get("nbPages");
        } else if (type == "text-active-page") {
            page = T.documentModel.get("page");
            service = "text";
            filename += "_" + page;
        } else {
            error_str = STR.something_wrong;
        }

        if (!error_str) {
            T.closePanel();
            T.trackEventReader('telecharger');
            //var url=T.documentModel.pageUrl(page)+"/"+service+"?filename="+filename;
            var url = T.app.rnapi + "/documents/" + T.publicationId + "/" + T.documentId + "/" + page + "/" + service + "?filename=" + filename;
            window.location = url;
        } else {
            T.notify({
                text: error_str,
                type: "warning",
                timeout: 4000
            });
        }
    },

    limitInputToNumbers: function (e) {
        var val = $(e.target).val();
        var new_val = val.replace(/[^0-9,-]/g, "");
        if (new_val != val) {
            $(e.target).val(new_val);
        }
    },

    checkPrintRangeSyntax: function (page_str, max_page) {
        if (page_str.length) {
            var page_spl = page_str.split(",");
            for (var i = 0; i < page_spl.length; i++) {
                var page_interval = page_spl[i];
                var page_interval_spl = page_interval.split("-");
                if (page_interval_spl.length == 1) {
                    var page = parseInt(page_interval_spl[0]);
                    if (isNaN(page) || page < 1 || page > max_page) {
                        return false;
                    }
                } else if (page_interval_spl.length == 2) {
                    var page_min = parseInt(page_interval_spl[0]);
                    var page_max = parseInt(page_interval_spl[1]);
                    if (isNaN(page_min) || page_min < 1 || page_min > max_page) {
                        return false;
                    }
                    if (isNaN(page_max) || page_max < 1 || page_max > max_page) {
                        return false;
                    }
                    if (page_min > page_max) {
                        return false;
                    }
                } else {
                    return false;
                }
            }
        } else {
            return false;
        }
        return true;
    },

    onPrintTextFocused: function () {
        this.$("#print-pdf-some-page").prop("checked", true);
    },

    onPrintDocumentClicked: function () {
        var T = this,
            page = 1,
            error_str = null;

        var type = T.$("input[name='print-group']:checked").val();
        if (type == "active-page") {
            page = T.documentModel.get("page");
        } else if (type == "some-pages") {
            page = T.$("#print-text-some-pages").val().trim();

            if (!T.checkPrintRangeSyntax(page, T.documentModel.get("nbPages"))) {
                error_str = STR.wrong_syntax_pages;
            }
        } else if (type == "all-pages") {
            page = "1-" + T.documentModel.get("nbPages");
        }

        if (!error_str) {
            //var url=T.documentModel.pageUrl(page)+"/pdf";
            var url = T.app.rnapi + "/documents/" + T.publicationId + "/" + T.documentId + "/" + page + "/pdf";

            T.closePanel();
            T.trackEventReader('imprimer');
            var w = window.open(url);
            if (w) {
                w.onload = function () {
                    w.print();
                };
            }
        } else {
            T.notify({
                text: error_str,
                type: "warning",
                timeout: 4000
            });
        }
    },

    /**
     * scroll to top
     */
    onScrollTopClicked: function () {
        $("html, body").animate({
            scrollTop: 0
        }, 500);
    },

    /**
     * http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
     * @param  {[type]}  el [description]
     * @return {Boolean}    [description]
     */
    isElementInViewport: function (el) {
        var rect = el.getBoundingClientRect();
        return !(
            rect.bottom <= 0 ||
            rect.top >= $(window).height()
        );
    },

    /**
     * go full screen
     */
    onFullscreenClicked: function () {
        var T = this,
            el = T.$(".reader")[0];

        if (T.isFullscreen()) {
            T.exitFullscreen();
        } else {
            T.enterFullscreen(el);
        }
    },

    onHelpClicked: function () {
        this.app.help();
        this.trackEventReader('aide');
    },

    onImageInverseClicked: function () {
        var T = this;
        T.imageInverse(!T._imageInverted);
        if(T._imageInverted){
            T.trackEventReader('negatif');
        }
    },

    imageInverse: function (invert) {
        var T = this;
        T._imageInverted = invert;
        T.$(".reader").toggleClass("inverted", invert);
        T.$(".image-inverse").toggleClass("on", invert);
    },

    onEntitiesClicked: function () {
        var T = this;

        if (T.documentModel.get("isTextMissing")) {
            T.notify({
                text: STR.text_is_missing,
                type: "warning",
                timeout: 5000
            });
        }
        T.displayEntities(!T._entitiesShown);
        if(T._entitiesShown){
            T.trackEventReader('afficher-tags');
        }
    },

    displayEntities: function (show) {
        var T = this;
        T._entitiesShown = show;
        T.$(".overlay-entities").toggleClass("hide", !show);
        T.$(".entities").toggleClass("on", show);
    },

    displayCrop: function (show) {
        var T = this;
        T._cropShown = show;
        T.$(".overlay-crop").toggleClass("hide", !show);
    },

    onPageAnnotationClicked: function (annotation_model) {
        var T = this;

        T.currentAnnotationModel = annotation_model;
        T.displayPanel("annotate");
    },

    displayAnnotation: function (show) {
        var T = this;
        T._annotateActive = show;

        T.$(".overlay-annotations").toggleClass("active", show);
    },

    onDeleteAnnotation: function () {
        var T = this;
        if (T.currentAnnotationModel) {
            //if(window.confirm(STR.confirm_delete_annotation)){
            T.currentAnnotationModel.destroy({
                error: function () {
                    T.notify({
                        text: STR.unable_to_save,
                        type: "error",
                        timeout: 4000
                    });
                }
            });
            T.currentAnnotationModel = null;
            T.closePanel();
            //}
        }
    },

    onSaveAnnotation: function () {
        var T = this;

        if (T.currentAnnotationModel) {
            T.currentAnnotationModel.save({
                text: T.$("#annotation-text").val()
            }, {
                    error: function () {
                        T.notify({
                            text: STR.unable_to_save,
                            type: "error",
                            timeout: 4000
                        });
                    }
                });
            T.currentAnnotationModel = null;
            T.closePanel();
            T.trackEventReader('annoter');
        }
    },

    onNextPage: function () {
        this.documentView.gotoPage("next", true);
    },

    onPreviousPage: function () {
        this.documentView.gotoPage("previous", true);
    },

    onZoomInClicked: function () {
        this.documentView.zoom("in", true);
        this.trackEventReader('zoom-plus');
    },

    onZoomOutClicked: function () {
        this.documentView.zoom("out", true);
        this.trackEventReader('zoom-moins');
    },

    onCalendarClicked: function () {
        var T = this;
        T.displayCalendar(!T._calendarShown);
        if(T._calendarShown){
            T.trackEventReader('calendrier');
        }
    },

    displayCalendar: function (show) {
        var T = this;

        if (T.embed) {
            return;
        }

        if (T._blocksShown && show) {
            T._blocksShown = false;
            T.$(".ocr").removeClass("on"); // button
            T.$(".overlay-blocks").addClass("hide");
        }
        T._calendarShown = show;
        if (T.blockView) {
            T.blockView.$el.hide(); // cache le panel et l'overlay
        }
        T.displaySidePanel(show);

        if (!T.calendarView) {
            T.calendarView = new CalendarView({
                documentModel: T.documentModel,
                app: T.app,
                userModel: T.userModel,
                searchAccess: T.searchAccess,
                queryModel: T.documentQueryModel,
                from: T.from,
                index: T.index
            });
            T.$(".side-panel").append(T.calendarView.el);
            T.calendarView.queryDocumentList();
        }
        else {
            T.calendarView.queryDocumentList();
            T.calendarView.$el.show();
        }
        T.$(".calendar").toggleClass("on", show); // button

        T.calendarView.gotoCurrent();
    },

    onOcrClicked: function () {
        var T = this;
        if (T.documentModel.get("isTextMissing")) {
            T.notify({
                text: STR.text_is_missing,
                type: "warning",
                timeout: 5000
            });
        }
        else{
            T.displayBlocks(!T._blocksShown);
            if(T._blocksShown){
                T.trackEventReader('mode-texte');
            }
        }
    },

    /**
     * display blocks in ocr text overlay
     * @param  {Bool} show
     */
    displayBlocks: function (show) {
        var T = this;

        if (T.embed) {
            return;
        }

        if (T._calendarShown && show) {
            T._calendarShown = false;
            T.$(".calendar").removeClass("on"); // button
        }
        T._blocksShown = show;
        if (T.calendarView) {
            T.calendarView.$el.hide(); // cache le panel
        }
        T.$(".overlay-blocks").toggleClass("hide", !show);
        T.$(".ocr").toggleClass("on", show); // button
        T.displaySidePanel(show);
        T.updateBlocksView();
    },

    /**
     * update text from ocr view
     */
    updateBlocksView: function () {
        var T = this,
            page = T.documentModel.get("page");

        if (!page) {
            return;
        }

        var semantic_model = T.getSemanticModel(page);
        var page_model = T.documentModel.getPageModel(page);

        if (T.blockView) {
            T.stopListening(T.blockView);
            T.blockView.close();
            T.blockView.$el.remove();
        }
        T.blockView = new BlocksView({
            model: semantic_model,
            pageModel: page_model,
            documentModel: T.documentModel,
            app: T.app,
            mode: T.blockMode,
            articleId: T.articleId
        });

        if (T.articleId) {
            T.articleId = null; // article initialement highlighté
        }

        T.$(".side-panel").append(T.blockView.el);

        T.listenTo(T.blockView, "click:block", T.onViewBlockClicked);
        T.listenTo(T.blockView, "change:mode", T.onViewBlockModeChanged);
        T.listenTo(T.blockView, "article:open", T.onViewBlockArticleOpen);
    },



    /**
     * synchronize ocr text position with clicked block into overlay view
     * @param  {[type]} overlay_view [description]
     * @param  {[type]} block_id     [description]
     */
    onPageBlockClicked: function (overlay_view, block_id) {
        var T = this;
        if (T.blockView) {
            T.blockView.gotoBlock(block_id);
        }
    },

    /**
     * highlight text block into overlay view
     * @param  {[type]} block_view [description]
     * @param  {array} block_ids   tableau de blocks ids qui ont été touchés
     * en mode page 1 seul bloc, en mode article l'ensemble des blocks correspondant à l'article
     */
    onViewBlockClicked: function (block_view, block_ids) {
        var T = this;
        T.$(".overlay-blocks .block").removeClass("hl");
        var selector = "";

        _.each(block_ids, function (block_id) {
            if (selector) {
                selector += ",";
            }
            selector += ".overlay-blocks #" + block_id;
        });

        T.$(selector).addClass("hl");
        setTimeout(function () {
            T.$(selector).removeClass("hl");
        }, 4000);
    },

    onViewBlockModeChanged: function (block_view, mode) {
        this.blockMode = mode;
    },

    onViewBlockArticleOpen: function (block_view, article_id) {
        var T = this;

        // update url avec cet article
        T.currentArticleId = article_id;
        T.updateRoute();
    },

    onBasketClicked: function () {
        var T = this;

        if (!T.documentModel.fetched) return;

        T.trackEventReader('acheter');

        if (T.embed) {
            // en mode embed, on va vers le lecteur complet
            window.open(T.canonicalReaderUrl(true, T.fit));
        }
        else {
            // dans le lecteur complet   
            if (T.userModel.isPro()) {
                // les utilisateurs pro peuvent acheter des droits
                T.app.addToBasket(T.documentModel);
            } else {
                // sinon ils doivent s'abonner à un abonnement pro
                T.app.proScreen();
            }
        }
    },

    onPageViewAdded: function (page_view) {
        var T = this,
            page = page_view.page,
            page_model = T.documentModel.getPageModel(page);

        if (!T.embed) {
            var semantic_model = T.getSemanticModel(page);

            // overlay entities
            var entities_view = new OverlayEntitiesView({
                pv5api: T.app.pv5api,
                page: page,
                hide: !T._entitiesShown,
                model: semantic_model
            });
            T.overlayViews.push(entities_view);

            // overlay search
            var page_query_model = new ArticleQueryModel({
                useAgg: false,
                documentId: T.documentId,
                publicationId: T.publicationId,
                highlight: true,
                highlightPosition: true,
                pageNumber: page,
                pageSize: 20, // on ne peut pas avoir plus de 20 articles par page
                highlightFragments: 1000,
                exact: true,
                access: T.searchAccess
            }, {
                    pv5api: T.app.pv5api,
                    minPublishedDate: T.app.minPublishedDate,
                    maxPublishedDate: T.app.maxPublishedDate,
                    page: page // pour la retrouver plus facilement par la suite
                });
            T._pageQueryModels.push(page_query_model);
            var search_view = new OverlaySearchView({
                page: page,
                pageModel: page_model,
                queryModel: page_query_model
            });
            T.overlayViews.push(search_view);

            // lancer la recherche que si il le faut
            if (T.isResultInPage(page)) {
                if (T.documentQueryModel.hasTerms()) {
                    T.copyQueryTerms(T.documentQueryModel, page_query_model);
                    page_query_model.search();
                }
            }

            // overlay blocks
            var blocks_view = new OverlayBlocksView({
                pv5api: T.app.pv5api,
                page: page,
                hide: !T._blocksShown,
                model: semantic_model
            });
            T.listenTo(blocks_view, "click:block", T.onPageBlockClicked);
            T.overlayViews.push(blocks_view);

            //annotations
            if (T.userModel.isLoggedIn()) {
                var annotations_view = new OverlayAnnotationsView({
                    page: page,
                    pageModel: page_model,
                    annotationCollection: T.annotationCollection,
                    active: T._annotateActive,
                    app: T.app
                });
                T.listenTo(annotations_view, "click:annotation", T.onPageAnnotationClicked);
                T.overlayViews.push(annotations_view);
            }

            //crop
            var crop_view = new OverlayCropView({
                pv5api: T.app.pv5api,
                page: page,
                pageModel: page_model,
                hide: !T._cropShown
            });
            T.overlayViews.push(crop_view);

        }

        // highlight : on ne l'ajoute que pour la page initiale
        if (page == T.page) {
            var highlight_view = new OverlayHighlightView({
                page: page,
                pageModel: page_model,
                highlight: T.highlight
            });
            T.overlayViews.push(highlight_view);
        }
    },

    onPageViewRendered: function (page_view) {
        var T = this;
        if (page_view.model.fetched) {
            var overlay_views = _.where(T.overlayViews, {
                page: page_view.page
            });

            overlay_views.forEach(function (overlay_view) {
                page_view.$tileContainer.append(overlay_view.el);
            });
        }
    },

    onPageViewRefreshed: function ( /*page_view*/) {
        //if you need to refresh positions in overlay_view
    },

    onPageViewRemoved: function (page_view) {
        var T = this;

        T._pageQueryModels = _.difference(T._pageQueryModels, _.where(T._pageQueryModels, {
            page: page_view.page
        }));

        if (page_view.model.fetched) {
            var overlay_views = _.where(T.overlayViews, {
                page: page_view.page
            });
            overlay_views.forEach(function (overlay_view) {
                overlay_view.remove();
                T.stopListening(overlay_view);
                overlay_view.close();
            });
            T.overlayViews = _.difference(T.overlayViews, overlay_views);
        }
    },

    /**
     * change button appearance when fullscreen change
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    onFullscreenChanged: function () {
        var T = this,
            fs = T.isFullscreen();

        $("body").toggleClass("full-screen", fs);
        T.$(".full-screen").toggleClass("on", fs); // mettre une class semble le plus stable, les pseudo class ne sont pas comprises par tous les navigateurs en 2015

        T.onResize();
    },

    isFullscreen: function () {
        return (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement || document.pv5FullScreen);
    },

    enterFullscreen: function (el) {
        var T = this;

        if (el.requestFullscreen) {
            el.requestFullscreen();
        } else if (el.webkitRequestFullscreen) {
            el.webkitRequestFullscreen();
        } else if (el.mozRequestFullScreen) {
            el.mozRequestFullScreen();
        } else if (el.msRequestFullscreen) {
            el.msRequestFullscreen();
        } else {
            //simulate fullscreen
            document.pv5FullScreen = true;
            T.onFullscreenChanged();
        }
        T.trackEventReader('plein-ecran');
    },

    exitFullscreen: function () {
        var T = this;
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else {
            document.pv5FullScreen = false;
            T.onFullscreenChanged();
        }
    },

    echoVersion: function () {
        var T = this;
        T.$(".version").html(T.app.version);
    },

    /**
     * Display a sliding message from bottom
     * @param  {Object} data
     * {
     *      text:text,
     *      type:"error", //"error","info"
     *      timeout:10000
     *  }
     */
    notify: function (data) {
        var T = this;

        if (T.notifyTimer) {
            clearTimeout(T.notifyTimer);
        }

        T.$(".notify").addClass("show");
        T.$(".notify > p").attr("class", data.type).html(data.text);

        if (data.timeout) {
            T.notifyTimer = setTimeout(function () {
                T.notifyClose();
                T.notifyTimer = 0;
            }, data.timeout);
        }

    },

    notifyClose: function () {
        this.$(".notify").removeClass("show");
    },

    /**
     * Appelé quand on clique sur un des boutons de la barre d'outils du haut qui affiche un panel la plupart du temps
     * @param  {Event} e
     */
    onDisplayPanel: function (e) {
        var T = this;
        var name = $(e.target).data("panel");
        if (name) {
            e.stopPropagation();
            T.closePanel();

            if (name == "embed") {
                T.updateEmbedCodePage();
            } else if (name == "annotate") {
                T.currentAnnotationModel = null;
                //tmp start
                /*if (!T.userModel.isAdmin()) {
                    T.app.comingSoonScreen();
                    return;
                }*/
                // tmp end
            } else if (name == "search") {
                if (T.documentModel.get("isTextMissing")) {
                    T.notify({
                        text: STR.text_is_missing,
                        type: "warning",
                        timeout: 5000
                    });
                }
            }

            T.displayPanel(name);
        }
    },

    /**
     * Appelé quand on clique sur la croix d'un des panels d'outils du haut
     * @param  {Event} e
     */
    onClosePanel: function (e) {
        var T = this;
        e.stopPropagation();
        T.closePanel();
    },

    /**
     * Ouvre un panel d'outils du haut
     * @param  {String} name nom du panel à ouvrir
     */
    displayPanel: function (name) {
        var T = this;
        T.openPanel = name;
        T.$(".tb-top .button." + name).addClass("on");
        if (name == "search") {
            T.$("#search-input-phrase").focus();
        } else if (name == "crop") {
            T.displayCrop(true);
        } else if (name == "annotate") {
            if (T.currentAnnotationModel) {
                T.$(".annotation-edit").show();
                T.$("#annotation-text")
                    .val(T.currentAnnotationModel.get("text"))
                    .focus();
            } else {
                T.$("#annotation-text").val("");
                T.$(".annotation-edit").hide();
            }
            T.displayAnnotation(true);
        } else if (name == "embed") {
            T.displayEmbedPreview(true);
        }
    },

    /**
     * Ferme le panel actuellement ouvert
     */
    closePanel: function () {
        var T = this;
        if (T.openPanel == "crop") {
            T.displayCrop(false);
        } else if (T.openPanel == "annotate") {
            T.displayAnnotation(false); // le click dans la page ne produit plus d'annotations
        } else if (T.openPanel == "embed") {
            T.displayEmbedPreview(false); // on vide la preview quand on en a plus besoin car elle est couteuse
        }

        T.$(".tb-top .button." + T.openPanel).removeClass("on");
    },

    displayEmbedPreview: function (show) {
        var T = this;
        T.$("#embed-preview-iframe").empty();
        if (show) {
            var $iframe = $(T.$("#embed-code").val());
            $iframe.attr({
                width: T.embedWidth,
                height: T.embedHeight
            }); // on écrase les dimensions sinon ça ne tiendrait jamais dans la popup
            T.$("#embed-preview-iframe").append($iframe);
        }
    },

    onMinimizePanel: function (e) {
        var T = this;
        var name = $(e.target).data("panel");
        if (name) {
            T.$(".tb-top .button." + name).toggleClass("minimized");
        }
    },

    /**
     * retourne l'url canonique officielle vers le reader dans le site retronews
     * @return {String} [description]
     */
    canonicalReaderUrl: function (use_start_page, fit, embed) {
        var T = this,
            url,
            pubtitle = T.documentModel.get("publicationTitle"),
            pubid = T.documentModel.get("publicationId"),
            docid = T.documentModel.get("id"),
            docdate = T.documentModel.get("published"),
            page = use_start_page ? T.page : T.documentModel.get("page"),
            base_url = embed ? T.app.canonicalEmbedUrl : T.app.canonicalUrl;

        url = base_url + "/" + UrlUtil.slugify(pubtitle) + "/" + UrlUtil.slugify(STR.date(docdate)) + "/" + pubid + "/" + docid + "/" + page;

        if (fit) {
            var fit_array = [fit.x, fit.y, fit.width, fit.height];
            url += "?fit=" + fit_array.join(".");
        }

        return url;
    },

    onBackToSearchClicked: function () {
        window.location = this.from;
    },

    /**
     * Initiate a search in document from panel
     */
    onSubmitSearch: function () {
        var T = this;


        // reset all search query and overlays
        T.resetPageQuery();

        // disable next / prev button
        T.enableResultButtons(false);

        // initiate a new search in document if request is not empty
        if (T.documentQueryModel.get("phrase")) {
            T.documentQueryModel.set({
                allTerms: null,
                someTerms: null,
                exact: true // forcé a true pour la recherche dans la page
            });
            T.notify({
                text: STR.search_in_progress,
                type: "info",
                timeout: 30000
            });
            T.documentQueryModel.search();
            T.trackEventReader('rechercher-dans-page');
        }

    },

    /**
     * Disable/enable prev/next result  button
     * @param  {Bool} enable
     */
    enableResultButtons: function (enable) {
        var T = this;
        T.$(".result .action").toggleClass("enable", enable);
    },


    onDocumentSearchEnd: function () {
        var T = this,
            results = T.documentQueryModel.get("results");

        if (results.length) {
            T.notifyClose();
            _.each(T._pageQueryModels, function (page_query_model) {
                if (T.isResultInPage(page_query_model.get("pageNumber"))) {
                    T.copyQueryTerms(T.documentQueryModel, page_query_model);
                    page_query_model.search();
                }
            });

            T.enableResultButtons(true);

            //go to the first result
            T.gotoResult("nearest");
        } else {
            T.notify({
                text: STR.no_result,
                type: "warning",
                timeout: 3000
            });
        }
    },

    /**
     * Reset page search queries and overlays
     */
    resetPageQuery: function () {
        var T = this;

        T.documentQueryModel.fetched = false;

        _.each(T._pageQueryModels, function (page_query_model) {
            page_query_model.fetched = false;
        });

        _.each(T.overlayViews, function (overlay_view) {
            if (overlay_view instanceof OverlaySearchView) {
                overlay_view.render();
            }
        });
    },

    /**
     * Determine if page is in result collection
     * @param  {Number}  p [description]
     * @return {Boolean}   [description]
     */
    isResultInPage: function (p) {
        var T = this,
            results = T.documentQueryModel.get("results"),
            found = false;

        if (T.documentQueryModel.fetched && results.length) {
            results.all(function (result) {
                var page = result.get("pageNumber")[0];
                if (page == p) {
                    found = true;
                    return false;
                }
                return true;
            });
        }

        return found;
    },

    copyQueryTerms: function (model_src, model_dest) {
        model_dest.set({
            allTerms: model_src.get("allTerms"),
            phrase: model_src.get("phrase"),
            someTerms: model_src.get("someTerms"),
            exact: model_src.get("exact")
        });
    },

    /**
     * Goto result, change page if needed
     * @param  {String} mode nearest, previous, next
     */
    gotoResult: function (mode) {
        var T = this,
            current_page = T.documentModel.get("page"),
            nearest_page = 0,
            results = T.documentQueryModel.get("results");

        if (T.documentQueryModel.fetched && results.length) {
            if (mode == "nearest") {
                results.all(function (result) {
                    var page = result.get("pageNumber")[0];
                    if (page >= current_page) {
                        nearest_page = page;
                        return false;
                    }
                    return true;
                });

                if (!nearest_page) {
                    nearest_page = results.first().get("pageNumber")[0];
                }
            } else if (mode == "next") {
                results.all(function (result) {
                    var page = result.get("pageNumber")[0];
                    if (page > current_page) {
                        nearest_page = page;
                        return false;
                    }
                    return true;
                });
                if (!nearest_page) {
                    nearest_page = results.first().get("pageNumber")[0];
                }
            } else if (mode == "previous") {
                var results_reversed = results.first(results.length).reverse();
                _.all(results_reversed, function (result) {
                    var page = result.get("pageNumber")[0];
                    if (page < current_page) {
                        nearest_page = page;
                        return false;
                    }
                    return true;
                });
                if (!nearest_page) {
                    nearest_page = results.last().get("pageNumber")[0];
                }
            }

            if (nearest_page && nearest_page != current_page) {
                // on va à la page
                T.documentView.gotoPage(nearest_page, true);
            }
        }
    },

    onNextResult: function () {
        var T = this;
        T.gotoResult("next");
    },

    onPreviousResult: function () {
        var T = this;
        T.gotoResult("previous");
    },

    /**
     * show/hide side panel
     * @return {[type]} [description]
     */
    displaySidePanel: function (show) {
        var T = this;
        T._sidePanel = show;

        var tb_h = T.$(".tb-top").height(),
            title_w = 380,
            is_phone = $(window).width() < 767 ? true : false;

        if (is_phone) {
            // en mode smartphone on affiche soit la version texte soit la version image
            T.$(".side-panel").css({
                width: "100%",
                top: tb_h,
                height: "calc( 100% - " + tb_h + "px)",
                display: show ? "block" : "none"
            });
            T.pageSliderView.$el.css({
                left: 0,
                width: show ? "100%" : ""
            });
            T.documentView.$el.css({
                left: 0,
                width: "100%",
                display: show ? "none" : "block"
            });
        }
        else {
            // autrement on affiche le texte + l'image
            T.documentView.$el.css({
                left: show ? title_w : "",
                width: show ? "calc( 100% - " + title_w + "px)" : "",
                display: "block"
            });
            T.pageSliderView.$el.css({
                left: show ? title_w : "",
                width: show ? "calc( 100% - " + title_w + "px)" : ""
            });
            T.$(".side-panel").css({
                width: title_w,
                top: tb_h,
                height: "calc( 100% - " + tb_h + "px)",
                display: show ? "block" : "none"
            });
        }

        T.onResize();
    },


    onActivateEmbed:function(){
        var T=this;
        if(T.overlayEmbedTimer){
            clearTimeout(T.overlayEmbedTimer);
            T.overlayEmbedTimer=null;
        }
        $(window).off(".overlay-embed");
        T.$overlayEmbed.remove();
        
        T.notify({
            text: STR.embed_activated,
            type: "info",
            timeout: 3000
        });
    },

    onOverlayEmbedMouseWheel:function(){
        var T=this;
        if(T.overlayEmbedTimer) return;
        T.$overlayEmbed.addClass("over");
        T.overlayEmbedTimer=setTimeout(function(){
            T.$overlayEmbed.removeClass("over");
            T.overlayEmbedTimer=null;
        },3000); // 3 secondes pour activer le lecteur
    },

    onOverlayEmbedTouchStart:function(){
        var T=this;
        debug("touchstart");

        $(window).on("pointerup.overlay-embed pointercancel.overlay-embed touchcancel.overlay-embed touchend.overlay-embed", function (e) {
            T.onOverlayEmbedTouchEnd(e);
        });
        
        T.$overlayEmbed.addClass("over");
    },

    onOverlayEmbedTouchEnd:function(){
        var T=this;
        debug("touchend");
        $(window).off(".overlay-embed");
        if(T.overlayEmbedTimer) return;
        T.overlayEmbedTimer=setTimeout(function(){
            T.$overlayEmbed.removeClass("over");
            T.overlayEmbedTimer=null;
        },3000); // 3 secondes pour activer le lecteur
    },


    /**
     * close each sub view and stop listening
     */
    close: function () {
        var T = this;

        T.writeSettings();

        T.subViews.forEach(function (view) {
            view.close();
        });
        T.subViews = null;

        if (T.blockView) {
            T.blockView.close();
            T.blockView.$el.remove();
            T.blockView = null;
        }
        if (T.calendarView) {
            T.calendarView.close();
            T.calendarView.$el.remove();
            T.calendarView = null;
        }

        $(document).off(".rn");
        $(window).off(".rn");

        T.stopListening();
        T.undelegateEvents();
    }

});